import { PlatformAddOns } from '../interfaces/platform';
import { ProductCatalogPlatforms } from '../interfaces/product-catalog';
import { CallsPlatformModel } from './calls-platform.model';
import { ConversationIntelligencePlatformModel } from './conversation-intelligence-platform.model';
import { FormsPlatformModel } from './forms-platform.model';
import { LeadCenterPlatformModel } from './lead-center-platform.model';
import { ConvertAssistPlatformModel } from './convert-assist-platform.model';
import { VoiceAssistPlatformModel } from './voice-assist-platform.model';
export class ProductCatalog {
  public platforms: ProductCatalogPlatforms;
  public add_ons: PlatformAddOns[];

  constructor(platformPlan) {
    Object.assign(this, platformPlan);
    this.setPlatforms();
  }

  private setPlatforms() {
    Object.keys(this.platforms).forEach((key) => {
      if (
        this.platforms[key]?.monthly?.base &&
        this.platforms[key]?.monthly?.premium
      ) {
        this.platforms[key] = [
          ...this.platforms[key].monthly.base,
          ...this.platforms[key].monthly.premium,
          ...this.platforms[key].annual.base,
          ...this.platforms[key].annual.premium,
        ].map((platform) => this.selectPLatformModel(key, platform));
      } else if (this.platforms[key]?.monthly) {
        this.platforms[key] = [
          ...this.platforms[key].monthly,
          ...this.platforms[key].annual,
        ].map((platform) => this.selectPLatformModel(key, platform));
      } else if (this.platforms && this.platforms[key]) {
        this.platforms[key] = this.platforms[key].map((platform) =>
          this.selectPLatformModel(key, platform)
        );
      }
    });
  }

  private selectPLatformModel(key, platform) {
    switch (key) {
      case 'calls':
        return new CallsPlatformModel(platform);
      case 'forms':
        return new FormsPlatformModel(platform);
      case 'conversation_intelligence':
        return new ConversationIntelligencePlatformModel(platform);
      case 'lead_center':
        return new LeadCenterPlatformModel(platform);
      case 'convert_assist':
        return new ConvertAssistPlatformModel(platform);
      case 'voice_assist':
        return new VoiceAssistPlatformModel(platform);
      default:
        return [];
    }
  }
}
